import React, { useEffect } from "react";
import { Modal, Button, Form, Input, Typography, Select, Avatar } from "antd";
import { useDispatch, useSelector } from "react-redux";
import {
    modalActions,
    statut_demandeActions,
    ticket_stateActions,
    type_ticketActions,
} from "../../../redux/_actions";
import { SaveOutlined, CloseCircleOutlined } from "@ant-design/icons";

const { Text } = Typography;
const { Option } = Select;

const ModalAjouterTicketState = (props) => {
    const dispatch = useDispatch();
    const closable_ticket_state = useSelector(
        (state) => state.modal.closable_ticket_state
    );
    const colors = useSelector((state) => state.project_color.items);

    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue({
            libelle: props.ticketState.state_name,
            id_color: props.ticketState.state_color,
        });
    });

    const submitAddColor = (values) => {
        if (Object.keys(props.ticketState).length === 0) {
            dispatch(ticket_stateActions.add(values));
            dispatch(modalActions.close_ticket_state());
            form.resetFields();
        } else {
            const data = {
                id_state: props.ticketState.id_state,
                libelle: values.libelle,
                id_color: values.id_color,
            };
            dispatch(ticket_stateActions.update(data));
            props.setTicketState({});
            dispatch(modalActions.close_ticket_state());
        }
    };

    return (
        <Modal
            title={
                Object.keys(props.ticketState).length === 0
                    ? "Ajouter ticket state"
                    : "Modifier ticket state"
            }
            visible={closable_ticket_state}
            footer={null}
            onCancel={() => {
                dispatch(modalActions.close_ticket_state());
                props.setTypeTicket({});
            }}
            maskClosable={false}
        >
            <Form
                className="login-form"
                onFinish={submitAddColor}
                form={form}
                layout="vertical"
            >
                <Form.Item>
                    <Form.Item
                        name="libelle"
                        style={{
                            display: "inline-block",
                            width: "calc(70% - 0px)",
                            marginRight: 2,
                            marginBottom: 0,
                        }}
                        label={<Text strong={true}>Libelle</Text>}
                        rules={[
                            {
                                required: true,
                                message:
                                    "Veuillez entrer le libellé du statut de la tache !",
                            },
                        ]}
                    >
                        <Input
                            size="large"
                            placeholder="Entrer le libellé du statut de la tache"
                        />
                    </Form.Item>
                    <Form.Item
                        name="id_color"
                        style={{
                            display: "inline-block",
                            width: "calc(29% - 0px)",
                            marginBottom: 0,
                        }}
                        label={<Text strong={true}>Couleur</Text>}
                        rules={[
                            {
                                required: true,
                                message:
                                    "Veuillez sélectionner la couleur du statut de la tache !",
                            },
                        ]}
                    >
                        <Select
                            style={{
                                width: "100%",
                            }}
                            size="large"
                            placeholder="Sélectionner la couleur du statut de la tache "
                            // defaultValue={
                            //     props.taskStatutSelected !== {}
                            //         ? [props.taskStatutSelected.id_color]
                            //         : null
                            // }
                        >
                            {colors.map((p) => (
                                <Option value={p.id_color}>
                                    <Avatar
                                        size="small"
                                        style={{
                                            backgroundColor: p.color,
                                        }}
                                    />
                                </Option>
                            ))}
                        </Select>
                    </Form.Item>
                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>
                    <Button
                        size="large"
                        type="default"
                        onClick={() => {
                            dispatch(modalActions.close_ticket_state());
                            props.setTicketState({});
                        }}
                    >
                        <CloseCircleOutlined /> Annuler
                    </Button>{" "}
                    <Button size="large" type="primary" htmlType="submit">
                        <SaveOutlined /> Enregistrer
                    </Button>
                </Form.Item>
            </Form>
        </Modal>
    );
};

export default ModalAjouterTicketState;
